<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-3">
        <view-mode-selector
          v-model="currentViewMode"
          @on-viewmode-changed="onViewModeChanged"
        />
      </div>
      <div class="col-sm-12 col-md-6 col-lg-9">
        <slot name="filters" />
      </div>
    </div>
    <div class="row">
      <view-data-range-selector
        :view-mode="currentViewMode"
        :year="year"
        @on-datarange-changed="onDatarangeChanged"
      />
    </div>
    <div class="row">
      <slot name="details" />
    </div>
  </div>
</template>
<script>
import ViewModeSelector from './ViewModeSelector';
import ViewDataRangeSelector from './ViewDataRangeSelector';

import calendarViewModes from '@/utils/shared/constants/calendarViewModes';

export default {
  name: 'FiscalCalendar',
  components: {
    ViewModeSelector,
    ViewDataRangeSelector,
  },
  inheritAttrs: true,
  props: {
    year: {
      type: Number,
      default: () => new Date().getFullYear(),
    },
  },
  data() {
    return {
      currentViewMode: calendarViewModes.Month,
    };
  },
  methods: {
    onViewModeChanged(selectedMode) {
      this.currentViewMode = selectedMode;
    },
    onDatarangeChanged(rangeData) {
      this.$emit('on-datarange-changed', rangeData);
    },
  },
};
</script>
